import { Column, Row, Text } from "@/components";

import { cn } from "@/lib/utils";

// The conversation a quote sits inside, rendered as an exchange. USER is the
// candidate; INTERNAL is whoever was on our side, which the row's principal
// already names. So the label comes in rather than being guessed here!
export const CandidacySourceThread = ({
  internalLabel,
  turns,
}: {
  internalLabel: string;
  turns: { speaker: "INTERNAL" | "USER"; text: string }[];
}) => {
  /* Render */
  const renderTurn = (
    { speaker, text }: { speaker: "INTERNAL" | "USER"; text: string },
    index: number,
  ) => {
    const isCandidate = speaker === "USER";

    return (
      <Row
        className={cn("w-full", isCandidate ? "justify-start" : "justify-end")}
        key={`${speaker}-${index.toString()}`}
      >
        <Column
          className={cn(
            "max-w-[88%] gap-1",
            isCandidate ? "items-start" : "items-end",
          )}
        >
          <Text className="font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-400">
            {isCandidate ? "Candidate" : internalLabel}
          </Text>
          <Text
            className={cn(
              "rounded-xl px-3 py-2 text-sm font-normal leading-relaxed text-slate-700",
              isCandidate
                ? "rounded-tl-sm border border-slate-200 bg-white shadow-sm"
                : "rounded-tr-sm border border-slate-200 bg-slate-100/70",
            )}
          >
            {text}
          </Text>
        </Column>
      </Row>
    );
  };

  const render = () => {
    if (!turns.length) return null;
    return <Column className="mt-2 gap-3">{turns.map(renderTurn)}</Column>;
  };

  return render();
};
